import AsyncStorage from '@react-native-async-storage/async-storage';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Global from '../constants/global';
import PrepareMarks from '../screens/PrepareMarks';
import ListImage from 'react-native-paper/lib/typescript/components/List/ListImage';
function removeFromArray(arr, id) {
  let index = arr.findIndex(el => el.id == id)
  if (index >= 0) {
    try {

      arr.splice(index, 1)
    } catch (e) {
      console.log(e)
    }
  }

}
export const listsTask = createSlice({
  name: 'list',

  initialState: {
    Posts: [],
    Users: [],
    MedicalMarks: {},
    PresentDays: {},
    Leaves: [],
    FinalData: [],
    WholeMarksLoaded: false,
    Classes: [],
    Subjects: [],
    Arrangement: [],
    ExamScheme: [],
    FinalResult: {},
    FinalMarksheet: [],
    ClassSubjectTeachersOnly: {},
    ClassTeachersOnly: {},
    ClassTeachersMix: {}, // to decide all teachers incl teacher and class teacher
    ExamMessages: {},
    ExamSubjects: {}, // to be carried in marks entry from preparemarks
    PreparedMarks: [],
    Notifications: [],
    Students: [],
    SubjectTeacher: [],
    Exams: [],
    InternalSummary: [],
    Marksheets: {},
    SummarySheet: {},
    ResultLogs: {},
    SubjectSheet: {},
    InternalData: {},
    Tarij: {},
    LockStatus: {},
    Marks: {},//this is all students, all subject only marks
    ResultReport: [],
    // ServerReportData:{},
    ExamDump: [],
    Donations: [],
    Numbering: [],
    stvm: [],
    Alert: { message: "" }
  },
  reducers: {
    remove(state, action) {
      let data = action.payload.data;
      let type = action.payload.type;
      removeFromArray(state[type], data.id)
    },
    setPosts(state, action) {
      // Use this for the first load (initial 10 posts)
      // We sort by stamp descending to ensure the latest posts are first
      const data = Array.isArray(action.payload)
        ? action.payload
        : action.payload?.payload
      
      state.Posts = data.sort((a, b) => b.stamp - a.stamp);
    },

    appendPosts(state, action) {
      // Use this for infinite scroll (adding more posts)
      const newPosts = Array.isArray(action.payload)
        ? action.payload
        : action.payload?.payload
      // To prevent duplicate posts if the same data is fetched twice
      const existingIds = new Set(state.Posts.map(p => p.id));
      const uniqueNewPosts = newPosts.filter(p => !existingIds.has(p.id));

      // Merge and Sort
      const updatedList = [...state.Posts, ...uniqueNewPosts];
      state.Posts = updatedList.sort((a, b) => b.stamp - a.stamp);
    },

    emptyList(state, action) {
      let type = action.payload.type;
      state[type] = []
    },
    updateDays(state, action) {
      //console.log("IN DAYS", action.payload.id)
      try {
        const got = state.FinalResult.Marksheets?.find(f => f.id == action.payload.id)
        if (got) {
          if (action.payload.total) {
            got.total = action.payload.total
          }
          if (action.payload.days) {
            got.present = action.payload.days
          }
          if (action.payload.mess) {
            got.mess = action.payload.mess
          }
          //console.log("GOT")

        } else {
          //console.log("not recd")
        }
      } catch { }

    },
    setMedicalmMarks(state, action) {
      if (!state.MedicalMarks[action.payload.yearStamp]) {
        state.MedicalMarks[action.payload.yearStamp] = {}
      }
      const c = state.MedicalMarks[action.payload.yearStamp]
      state.MedicalMarks[action.payload.yearStamp] = { ...c, ...action.payload.data }
    },

    setFinalMarksheet(state, action) {
      state.FinalMarksheet = { sheets: action.payload.data, year: action.payload.year, subjects: action.payload.subjects, std: action.payload.std, exam: action.payload.exam }
    },
    setFianlReport(state, action) {
      state.FinalResult = action.payload.data
      state.FinalResult.data = action.payload.data
      state.FinalResult.Marksheets = action.payload.Marksheets
      state.FinalResult.std = action.payload.std
      state.FinalResult.year = action.payload.year
      state.FinalResult.subjects = action.payload.subjects
    },
    Alert(state, action) {
      state["Alert"] = action.payload
    },
    updateRank(state, action) {
      const list = action.payload.data
      list.map((i) => {
        try {
          state.Marks[i.key].Summary.rank = i.rank
        } catch { }
      })
    },
    setPresentDays(state, action) {
      const cid = action.payload.cid
      if (!state.PresentDays[cid]) {
        state.PresentDays[cid] = {}
      }
      if (action.payload.data) {
        state.PresentDays[cid] = action.payload.data
      }
      // if (action.payload.message){
      //   state.PresentDays[cid].mess = action.payload.message
      // }
      // if (action.payload.total){
      //   state.PresentDays[cid].total = action.payload.total
      // }
      // if (action.payload.list){
      //   const list = action.payload.list
      //   list.map((i) => {
      //     try {
      //       state.PresentDays[cid][i.id] = i
      //     } catch { }
      //   })

      // }
    },

    updateMarkssList(state, action) {
      const year = action.payload.year
      const examName = action.payload.examName
      const es = action.payload.examClass?.subjects
      const allStudents = action.payload.allStudents
      const std = action.payload.std

      allStudents.map((student) => {

        const cid = Global.StudentExamYearIdO({
          studentId: student.id,
          examName: examName,
          stdId: std.id,
          year: year
        })


        let d = {}
        if (state.Marks[cid]) {
          d = { ...state.Marks[cid] }
        }
        const self = {}
        ////console.log("INSIDE CID", cid)
        Object.keys(action.payload.data).forEach(function (key, index) {
          ////console.log("INSIDE", cid, action.payload.data[key].eid)
          if (action.payload.data[key].eid == cid) {
            // //console.log("DDON", cid, action.payload.data[key].eid)
            self[key] = action.payload.data[key]
          }
        })

        if (Object.keys(self).length > 0) {
          d = { ...d, ...self }
          // //console.log("updating marks 1", self)


          // extracting only subjects required - stream
          const stream = student["class" + year]?.stream ? student["class" + year]?.stream : 0
          const examSubjects = es?.filter(s => { // student's stream relavant subjects
            const sstream = s?.stream ? s?.stream : 0
            return ((sstream == 0) || (stream == sstream)) && s?.totalMarks > 0
          })

          // //console.log("marks3 update", examSubjects, self)
          const summaryInfo = Global.GenerateSubResult(cid, examSubjects, self)
          summaryInfo.student = student
          // //console.log("marks3", summaryInfo)

          state.Marks[cid] = { ...d, Summary: summaryInfo }
        }



        // GenMarks(state, {
        //   payload: {
        //     allData: me,
        //     student: s,
        //     year: year,
        //     cid: cid,
        //     eSubjects: examSubjects,
        //   }
        // })

      })
      ///////// GENERATE COMBO ME
      // const me = {}
      // data.map((s) => {
      //   const cid = Global.StudentExamYearIdO({
      //     studentId: s.studentId,
      //     examName: s.examId,
      //     stdId: s.stdId, year: s.year
      //   })
      //   //console.log("cid", cid, s.subject.id)
      //   me[cid + s.subject.id] = s


      //   const student = allStudents.find(f => f.id == s.studentId)

      // })


    },
    updateMarks(state, action) {
      const student = action.payload.student
      const year = action.payload.year
      const examClass = action.payload.examClass
      const cid = action.payload.cid
      // //console.log("updating marks", student, year, examClass, cid)
      let d = {}
      if (state.Marks[cid]) {
        d = { ...state.Marks[cid] }
      }
      // //console.log("listcid cid", cid)

      // //console.log("listcid d", d)

      let d1 = action.payload.data ? action.payload.data : {}
      d = { ...d, ...d1 }
      // //console.log("listcid d1", d1)
      // extracting only subjects required - stream
      const stream = student["class" + year]?.stream ? student["class" + year]?.stream : 0
      const examSubjects = examClass?.subjects?.filter(s => { // student's stream relavant subjects
        const sstream = s?.stream ? s?.stream : 0
        return ((sstream == 0) || (stream == sstream)) && s?.totalMarks > 0
      })

      const summaryInfo = Global.GenerateSubResult(cid, examSubjects, d)
      summaryInfo.student = student

      state.Marks[cid] = { ...d, Summary: summaryInfo }
      // //console.log("marks3", state.Marks[cid])
    },

    setServerReportData(state, action) {
      const year = action.payload.year
      const classId = action.payload.classId
      const examName = action.payload.examName
      state.ResultReport[classId + year + examName] = action.payload.data

    },
    setMessage(state, action) {
      const stamp = action.payload.classStamp
      state.ExamMessages[stamp] = action.payload.data
    },
    setReportsLog(state, action) {
      const year = action.payload.year
      const classId = action.payload.classId
      const examName = action.payload.examName
      const id = action.payload.id
      const list = action.payload.list
      if (list.length) {
        if (!state.ResultLogs[id]) {
          state.ResultLogs[id] = []
        }
        const n = []
        list.map(l => {
          // //console.log("g",l.classStamp,state.ResultLogs[id])
          const g = state.ResultLogs[id]?.find(f => f.classStamp == l.classStamp)
          if (!g) {
            n.push({
              year: year,
              classId: classId,
              id: id,
              data: l
            })
          }
        })
        n?.map(nn => state.ResultLogs[id].push(nn))
        // state.ResultLogs[id].push(n)
        // //console.log(id, n)

      }
    },
    setInternalSummary(state, action) {
      const year = action.payload.year
      const classId = action.payload.classId
      const examName = action.payload.examName
      const list = action.payload.list
      state.InternalSummary[classId + year + examName] = list
    },
    setDataReceived(state, action) {
      state.WholeMarksLoaded = action.payload.received
    },
    setInternalData(state, action) {
      const year = action.payload.year
      const classId = action.payload.classId
      const examName = action.payload.examName
      if (!state.InternalData[classId + year + examName]) {
        state.InternalData[classId + year + examName] = []
      }
      const nlist = []
      state.InternalData[classId + year + examName].map(t => {
        nlist?.push(t)
      })
      //console.log("setting internal data")
      action.payload.internal?.map(p => {
        try {
          // //console.log("listp p", p)
          const got = state.InternalData[classId + year + examName]?.find(f => f.id == p.id)
          if (!got) {
            // //console.log("listp add", p)
            nlist.push(p)
          }
        } catch (e) {
          //console.log(e, p)
          //console.log(state.InternalData[classId + year + examName])
        }
      })
      // //console.log("list total", nlist)
      state.InternalData[classId + year + examName] = nlist
      // //console.log("fetch",classId + year + examName)
      // //console.log("list total", nlist)
      //  //console.log("list state", state.InternalData[classId + year + examName])

      // //console.log("listres", state.InternalData[classId + year + examName])
    },
    setFinalData(state, action) {

      const arr = []
      state.FinalData.map(e => {
        arr.push(e)
      })
      action.payload.data.map(e => {
        arr.push(e)
      })
      state.FinalData = arr
    },
    setReports(state, action) {
      const year = action.payload.year
      const classId = action.payload.classId
      const examName = action.payload.examName
      const conId = classId + year + examName
      //      //console.log("settingReport", conId + "END")
      state.Tarij[classId + year + examName] = action.payload.tarij
      state.SubjectSheet[conId] = action.payload.SubSheet
      // //console.log("settingReport", state.SubjectSheet[classId + year + examName])
      state.SummarySheet[classId + year + examName] = action.payload.SummSheet
      state.Marksheets[classId + year + examName] = action.payload.Marksheets
      if (action.payload.lockStatus) {
        state.LockStatus[classId + year + examName] = action.payload.lockStatus
      }
    },
    updateClassTeachers(state, action) {
      // this mathod creates object of classTeachers and subjectTeachers, for easy use
      const clid = action?.payload?.classId
      const type = action?.payload?.type
      try {
        const mixid = action.payload.onlyClassId + action.payload.year + action.payload.examNo
        if (!state[type][clid]) {
          state[type][clid] = []
        }
        if (!state["ClassTeachersMix"][mixid]) {
          state["ClassTeachersMix"][mixid] = []
        }


        if (action.payload.subject) {  // to settle subject teacher
          const got = state[type][clid].find(f => f.subject.id == action.payload.subject.id)
          if (!got) {
            state[type][clid].push(action.payload.teacher)

            state["ClassTeachersMix"][mixid].push(action.payload.teacher.teacherId)
          }


        } else { // to settle class teacher
          const got = state[type][clid].find(f => f.id == clid)
          if (!got) {
            state[type][clid].push(action.payload.teacher)
            state["ClassTeachersMix"][mixid].push(action.payload.teacher.teacherId)
          }

        }

      } catch { }
    },

    updateActivity(state, action) {
      let data = action.payload.data;
      let type = action.payload.type;
      let tochk = "id";
      if (action.payload.tocheck) {
        tochk = action.payload.tocheck;
      }
      if (action.payload?.isArray) {
        for (let i = 0; i < action.payload.data.length; i++) {
          try {
            let row = action.payload.data[i]
            if (row) {
              if (row?.data?.flag == -10) {
                removeFromArray(state[type], row.data.id)
              } else {
                if (row.data[tochk]) {
                  let index = state[type].findIndex(el => el[tochk] === row.data[tochk])
                  if (index >= 0) {
                    state[type][index] = row.data;
                  } else {
                    state[type].push(row.data);
                  }
                }
              }
            }
          } catch (err) {
            //     //console.log("redux list updation error", err)
          }

        }

      } else {
        if (data) {
          if (data.flag == -10) {
            removeFromArray(state[type], data.id)
          } else {
            if (data[tochk]) {
              let index = state[type].findIndex(el => el[tochk] === data[tochk])
              if (index >= 0) {
                state[type][index] = data;
              } else {
                state[type].push(data);
              }
            }
          }
        }
      }
      if (action.payload?.refresh) {
        state[type] = [...state[type]]
      }
    },
    setActivityList(state, action) {
      let type = action.payload.type
      let list = action.payload.list
      state["List"] = list;

    },
    updateBadgeCount(state, action) {
      const fnd = state.Counts.find(e => e.id == action.payload.id)
      if (fnd) {
        fnd.count = action.payload.count
      } else {
        state.Counts.push({ id: action.payload.id, count: action.payload.count })
      }
    },

    serverUpdate(state, action) {
      let raw = JSON.parse(action.payload);
      let data = raw.INFO
      if (data) {
        if (data?.id) {
          let index = state[raw.TYPE].findIndex(el => el.id === data.id)
          ////console.log.log("checking index", index);
          if (index >= 0) {
            state[raw.TYPE][index] = data;
          } else {
            state[raw.TYPE].unshift(data);
          }
        }
      }
    },
  },
})


export default listsTask.reducer;

function GenMarks(state, action) {
  const student = action.payload.student
  const year = action.payload.year
  const examClass = action.payload.examClass
  const cid = action.payload.cid
  let d = {}
  if (state.Marks[cid]) {
    d = { ...state.Marks[cid] }
  }
  let d1 = action.payload.data ? action.payload.data : {}
  d = { ...d, ...d1 }

  // extracting only subjects required - stream
  const stream = student["class" + year]?.stream ? student["class" + year]?.stream : 0
  const examSubjects = examClass?.subjects?.filter(s => { // student's stream relavant subjects
    const sstream = s?.stream ? s?.stream : 0
    return ((sstream == 0) || (stream == sstream)) && s?.totalMarks > 0
  })

  const summaryInfo = Global.GenerateSubResult(cid, examSubjects, d)
  summaryInfo.student = student
  // //console.log("listcid", cid, d, summaryInfo)
  state.Marks[cid] = { ...d, Summary: summaryInfo }

}